import type { ReviewAcknowledgement } from "@/types";
import { describeAdvisory } from "./advisoryCopy";

/** Checks the review rail records that are not advisories, in reviewer words. */
const NAMED_CHECKS: Record<string, string> = {
  paid_through_date: "Paid through date",
  layout: "Layout checked against the source",
  money_columns: "Money and date columns",
  claimant_count: "Claimant count",
  ytd_reconciliation: "YTD against the source",
  dates_are_right: "Dates are right",
};

/**
 * Reviewer-facing label for a stored acknowledgement (#7550 AC9). Advisory
 * checks ("advisory:<kind>") take the review rail's title for that kind; named
 * checks have fixed copy; anything else is humanised from its key so a raw
 * "paid_through_date" never reaches the page.
 */
export const acknowledgementLabel = (ack: Pick<ReviewAcknowledgement, "check" | "detail">): string => {
  const check = ack.check ?? "";
  if (check.startsWith("advisory:")) {
    const kind = check.slice("advisory:".length);
    return describeAdvisory({ kind, message: ack.detail ?? "" }).title;
  }
  if (NAMED_CHECKS[check]) return NAMED_CHECKS[check];
  const humanised = check.replace(/[_:-]+/g, " ").trim();
  return humanised ? humanised.charAt(0).toUpperCase() + humanised.slice(1) : "Check confirmed";
};
